import { useEffect, useState, useMemo } from 'react'
import { ConvertPriceToString } from '../../../Helpers/CustomConverter'
import { IoIosArrowBack } from 'react-icons/io';
import DiscountCode from '../../../Components/Components/DiscountCode';
import ContactSection from '../../Components/ProductPage/ContactSection';
import { useAuth } from '../../../Providers/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../../Providers/CartProvider';
import { toast } from 'react-toastify';
import useCheckLicense from '../../../Hooks/useCheckLicense.ts';
import { Licenses } from '../../../Data/Licenses.ts';
import { useParams } from '../../../Providers/ParamsProvider.jsx';
import { useOffers } from '../../../Providers/OffersProvider.jsx';

const CartPageIndexSideBar = ({ currentStage, prevStage, nextStage, lockProceed, getLoadingDisabledButton }) => {
    const { cartItems } = useCart()
    const navigate = useNavigate()
    const { authState } = useAuth()
    const { cartTotalNet, cartTotalGross, cartTotalTax, getBasketTotalValue } = useCart()
    // const [offerItemsTotalNet, setOfferItemsTotalNet] = useState(0)
    // const [offerItemsTotalGross, setOfferItemsTotalGross] = useState(0)
    // const [offerItemsTax, setOfferItemsTax] = useState(0)
    const { checkLicense } = useCheckLicense()
    const [isValidLicense, setIsValidLicense] = useState(checkLicense([Licenses.TgInstalacje]))
    const { isMobile } = useParams()
    const { orderItemsFromOffer } = useOffers()


    // useEffect(() => {
    //     if (offerItems.length > 0) {
    //         const offerItemsTotalNet = offerItems.reduce((total, product) => {
    //             return total + (product.costNet * product.qty)
    //         }, 0)
    //         const offerItemsTotalGross = offerItems.reduce((total, product) => {
    //             return total + (product.costGross * product.qty)
    //         }, 0)
    //         setOfferItemsTotalNet(offerItemsTotalNet)
    //         setOfferItemsTotalGross(offerItemsTotalGross)
    //         setOfferItemsTax(offerItemsTotalGross - offerItemsTotalNet)
    //     }
    // }, [])

    const getPrimaryButtonText = () => {
        switch (currentStage) {
            case 1:
                return 'Zamów teraz';
            case 2:
                return 'Przejdź do podsumowania';
            case 3:
                return 'Zamawiam';
        }
    }

    const handleOfferButtonClick = (isRetailerOffer) => {
        if (cartItems.basketItems.length === 0) {
            const warningText = isRetailerOffer || authState.user.isOperator ? 'ofertę' : 'zapytanie ofertowe'
            toast.warning(`Dodaj produkty do koszyka, aby na ich podstawie utworzyć ${warningText}!`)
            return
        }
        const mode = isRetailerOffer ? '1' : '0'
        navigate(`/OfferRequest/${mode}/false/null`)
    }

    const getSumNet = () => {
        if (orderItemsFromOffer.length > 0) {
            return ConvertPriceToString(getBasketTotalValue(orderItemsFromOffer).totalNet)
            //return ConvertPriceToString(offerItemsTotalNet)
        }
        else {
            return ConvertPriceToString(cartTotalNet)
            //return cartItems && cartItems.basketItems && cartItems.basketItems[0] ? ConvertPriceToString(basketTotalPriceNet, cartItems.basketItems[0].currency) : ConvertPriceToString(0.00)
        }

    }

    const getSumGross = () => {
        if (orderItemsFromOffer.length > 0) {
            return ConvertPriceToString(getBasketTotalValue(orderItemsFromOffer).totalGross)
            //return ConvertPriceToString(offerItemsTotalNet)
        }
        else {
            return ConvertPriceToString(cartTotalGross)
            //return cartItems && cartItems.basketItems && cartItems.basketItems[0] ? ConvertPriceToString(basketTotalPriceNet, cartItems.basketItems[0].currency) : ConvertPriceToString(0.00)
        }
    }


    const getVat = (totalNet, totalGross) => {
        if (orderItemsFromOffer.length > 0) {
            //return ConvertPriceToString(offerItemsTax)
            return ConvertPriceToString(getBasketTotalValue(orderItemsFromOffer).totalTax)
        }
        else {
            //return ConvertPriceToString(basketTotalTax)
            return ConvertPriceToString(cartTotalTax)
        }
    }

    const generateNavButtons = () => {
        if (orderItemsFromOffer && orderItemsFromOffer.length > 0) {
            return <button className={`btn-app-primary mb-3 ${primaryButtonStyle}`} onClick={nextStage}>{getPrimaryButtonText()}</button>
        }
        else {
            return (<>
                <button className={`btn-app-primary mb-3 ${primaryButtonStyle}`} onClick={nextStage}>{getPrimaryButtonText()}</button>
                {isValidLicense && <button className={currentStage !== 1 ? 'collapse' : 'btn-app-secondary mb-3'} onClick={() => handleOfferButtonClick(false)}>{offerRequestText}</button>}
                {isValidLicense && <button className={currentStage !== 1 ? 'collapse' : `${prepareRetailerOfferButtonStyle} btn-app-secondary mb-3`} onClick={() => handleOfferButtonClick(true)}> Przygotuj ofertę dla klienta </button>}
            </>)
        }
    }

    const returnButtonVisibility = currentStage === 1 ? 'collapse' : ''
    const contactSectionVisibility = currentStage === 1 || (orderItemsFromOffer.length > 0 && currentStage === 2) ? '' : 'collapse'
    const emptyBasketVisibility = cartItems.basketItems && cartItems.basketItems.length > 0 || orderItemsFromOffer.length > 0 ? '' : 'd-none'
    const primaryButtonStyle = cartItems.basketItems && cartItems.basketItems.filter(x => x.isSelected).length > 0 || orderItemsFromOffer.length > 0 ? '' : 'btn-app-disabled'
    const prepareRetailerOfferButtonStyle = authState.user && authState.user.isOperator ? 'collapse' : ''
    const discountCodeVisibility = orderItemsFromOffer.length > 0 ? 'collapse' : ''
    const offerRequestText = authState.user && authState.user.isOperator ? 'Przygotuj ofertę dla klienta' : 'Złóż zapytanie ofertowe '

    return (
        <div className={`row ${isMobile ? '' : 'newBasketPage-cart-summary'} main-container-holder ms-0 me-0`}>
            <div className='row mb-3'>
                <div className='col'>Suma netto</div>
                <div className='col-auto'>
                    {getSumNet()}
                </div>
            </div>
            <div className='row basket-page-underline'>
                <div className='col'>VAT</div>
                <div className='col-auto mb-3'>
                    {getVat()}
                </div>
            </div>
            <div className="row basket-page-underline">
                <div className="col mt-3 mb-3">
                    <b>Suma brutto</b>
                </div>
                <div className="col-auto mt-3">
                    {getSumGross()}
                    {/* {getSumGross(offerItemsTotalGross, offerItems, cartItems, basketTotalPriceGross)} */}
                </div>
            </div>
            <div className={`row mt-3 ${discountCodeVisibility}`}>
                <div className="col-12">
                    <DiscountCode />
                </div>
            </div>
            <div className={`${emptyBasketVisibility} d-flex flex-column mt-5`}>
                {lockProceed ? (
                    <>
                        {authState.user && authState.user.isOperator ? (<>
                            {getLoadingDisabledButton()}
                            {getLoadingDisabledButton()}
                        </>)
                            :
                            (<>
                                {getLoadingDisabledButton()}
                                {getLoadingDisabledButton()}
                                {getLoadingDisabledButton()}
                            </>)}
                    </>
                ) :
                    (
                        <>
                            {generateNavButtons()}
                        </>
                    )}
                <div className={`${returnButtonVisibility} d-flex item-align-center justify-content-center`} style={{ cursor: 'pointer' }} onClick={prevStage}>
                    <IoIosArrowBack size={24} />
                    <span>Poprzedni krok</span>
                </div>
            </div>
            <div className={`${contactSectionVisibility} row mt-3`}>
                <ContactSection />
            </div>
        </div>
    )
}

export default CartPageIndexSideBar